import * as React from "react";
import {
  Pressable,
  ScrollView,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import { Image } from "expo-image";
import { Link } from "expo-router";
import { Feather } from "@expo/vector-icons";
import { decodeEntity } from "html-entities";
import { observer } from "mobx-react-lite";

import { useAccountActions } from "~/components/AccountActions/context";
import { PageMeta } from "~/components/PageMeta";
import { useGetR2AssetURL } from "~/hooks/useGetR2AssetURL";
import { icons, isWeb } from "~/lib/constants";
import { useAccountStore } from "~/stores/space";
import { Button } from "~/ui/Button";

function WorkspacesPage() {
  const { store: account } = useAccountStore();
  const accountActions = useAccountActions();
  const { getR2AssetURL } = useGetR2AssetURL();
  return (
    <>
      <ScrollView>
        <PageMeta title="Workspaces" />
        <View className="container gap-4 py-4">
          <View className="flex-row items-center gap-2">
            <Text className="text-text-primary text-2xl font-semibold">
              Workspaces
            </Text>
            <Button
              variant="outline"
              size="small"
              onPress={() => accountActions.openAddSpace()}
            >
              <Feather name="plus" size={20} className="text-icon" />
            </Button>
          </View>

          <View className="grid gap-4 web:grid-cols-[repeat(auto-fill,minmax(275px,1fr))]">
            {account.spacesAsArrayWithoutBacklog.map((space) => (
              <View key={space.id} className="group relative">
                <Link
                  href={
                    isWeb
                      ? {
                          pathname:
                            "/(app)/(authenticated)/[account]/(space)/[space]/saves",
                          params: {
                            account: account.slug,
                            space: space.slug,
                          },
                        }
                      : {
                          pathname:
                            "/(app)/(authenticated)/[account]/(space)/[space]",
                          params: {
                            account: account.slug,
                            space: space.slug,
                          },
                        }
                  }
                  asChild
                >
                  <Pressable className="overflow-hidden rounded-lg">
                    <View className="relative h-48">
                      <Image
                        source={
                          space.r2Key ? getR2AssetURL(space.r2Key) : undefined
                        }
                        contentFit="cover"
                        style={{
                          width: "100%",
                          height: "100%",
                        }}
                        placeholder={{
                          uri: "thumbhash:/1QcSHQRnh493V4dIh4eXh1h4kJUI",
                        }}
                        className="h-full w-full"
                        alt={space.displayName ?? ""}
                      />
                      {typeof space.r2Key !== "string" && (
                        <Text className="text-text-primary absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 text-5xl font-semibold">
                          {space.displayName?.slice(0, 2).toUpperCase()}
                        </Text>
                      )}
                    </View>
                    <View className="bg-surface-secondary p-4">
                      <Text className="text-text-primary text-lg font-semibold">
                        {space.displayName}
                      </Text>
                      <Text className="text-text-secondary">
                        {space.savesCount} saves {decodeEntity("&bull;")}{" "}
                        {space.collectionsCount} collections{" "}
                        {decodeEntity("&bull;")} {space.tagsCount} tags
                      </Text>
                    </View>
                  </Pressable>
                </Link>
                <TouchableOpacity
                  className="bg-surface-primary border-divider absolute right-2 top-2 rounded-full border p-2 opacity-0 transition-opacity duration-200 group-hover:opacity-100"
                  onPress={() =>
                    accountActions.openEditSpace({ spaceId: space.id })
                  }
                >
                  <Feather
                    name={icons.edit.web}
                    size={16}
                    className="text-icon"
                  />
                </TouchableOpacity>
              </View>
            ))}
          </View>
        </View>
      </ScrollView>
    </>
  );
}
export default observer(WorkspacesPage);
